(function(){
    angular
        .module('app')
        .directive('ngCrop', crop);

        crop.$inject = ['$timeout'];
        function crop($timeout){
            return {
            restrict:'A',
            replace: true,
        	transclude: true,
            link: function (scope, element, $attrs) {
                return $timeout(function () {
                    var value = $attrs.value;
                    var $element = $(element);
                   	var button = $element, interval;
                   	var foto = scope.foto;
                    scope.$watch("foto.width",
                     function(value) {
                        var width = "";
                        var height = "";
                        if(typeof foto.size == 'undefined'){
                          width = foto.isize[0];
                        }else{
                          width = foto.size[0];
                        }
                        if(typeof foto.size == 'undefined'){
                          height = foto.isize[1];
                        }else{
                          height = foto.size[1];
                        }
                        $element.Jcrop({
                          aspectRatio: foto.width/foto.height,
                          minSize: [100,100],
                          setSelect: [0,0,9999,9999],
                          boxWidth: 500,
                          boxHeight: 500,
                          allowSelect: false,
                          onChange: scope.showCoords,
                          onSelect: scope.showCoords,
                          trueSize: [width,height]
                          },function(){ jcrop_api=this});
                         }
                    );
                });
            }
          }
      }
})();